import UsersListTable from './users-list-table'

export default UsersListTable